import { createPortal } from 'react-dom';
import type { ReactNode, ReactPortal } from 'react';

export interface PortalProps {
  children: ReactNode;
  /** Defaults to `document.body`. */
  container?: HTMLElement | null;
}

/** Renders `children` outside the DOM tree while keeping them in the React tree. */
export function Portal({ children, container }: PortalProps): ReactPortal | null {
  if (typeof document === 'undefined') return null;
  return createPortal(children, container ?? document.body);
}
